
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contentintelligence/tools/[tool]",
      function () {
        return require("private-next-pages/contentintelligence/tools/[tool].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contentintelligence/tools/[tool]"])
      });
    }
  